import Vue from 'vue'
import Message from '@/utils/message'
import Notification from '@/utils/notification'
import {
  Button,
  Select,
  Input,
  Option,
  Image,
  Link,
  Loading,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Pagination,
  Breadcrumb,
  BreadcrumbItem,
  Tree,
  Tooltip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Progress
} from 'element-ui'

const comList = [
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Select,
  Input,
  Option,
  Image,
  Link,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Pagination,
  Tree,
  Tooltip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Progress
]

comList.forEach((item) => {
  Vue.use(item)
})

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
